import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Motor de Reservas BITZ';

  constructor(
    private activatedRoute: ActivatedRoute,
    private spinnerService: NgxSpinnerService
  ) { }

  ngOnInit() {
    //this.activatedRoute.params.subscribe( (params) => {console.log(params)});
    this.spinner();
  }

  
  spinner(): void {
    this.spinnerService.show();
    setTimeout(() =>{
      this.spinnerService.hide();
    }, 2000);
  }

}
 